var render = function render(){var _vm=this,_c=_vm._self._c;return _c('md-table',_vm._g(_vm._b({},'md-table',_vm.$attrs,false),_vm.$listeners),[_vm._t("default"),_vm._v(" "),_c('md-table-row',{directives:[{name:"show",rawName:"v-show",value:(_vm.value.length),expression:"value.length"}]},[_vm._l((_vm.tableHeaders),function(header){return _c('md-table-cell',{key:header},[_vm._v(_vm._s(header))])}),_vm._v(" "),_c('md-table-cell',[_vm._v("Acciones")])],2),_vm._v(" "),_vm._l((_vm.value),function(item){return [_vm._t("md-table-row",null,{"item":item})]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }


// WEBPACK FOOTER //
// ./src/components/Tables/BaseTable.vue